import React, { useMemo, useEffect, useState } from 'react';
import AuthSocial from './social';
import CommanTab from './signUpTab';
import { history } from '../../history';
// import CandidateStep2 from './candidate/CandidateStep2';
import CandidateStep3 from './candidate/CandidateStep3';
import ManagerStep3 from './manager/ManagerStep3';
// import ManagerStep2 from './manager/ManagerStep2';
import websitelogo from '../../assets/img/offerx-logo.svg';
import IconCandidate from '../../assets/icons/candidate-1.svg';
import IconManager from '../../assets/icons/frame-1700.svg';
import queryString from 'query-string';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { routes } from '../routes/routes-names';
import PageLoader from '../../components/loader';
import compDetails from '../../assets/img/comp-details.png';
import candiDetails from '../../assets/img/Candidate-ver.svg';
import { Helmet } from 'react-helmet';
import CustomAuth from './custom-auth/CustomAuth';
import ManagerSingleRegistrationPage from './manager/ManagerSingleRegistrationPage';
import RegistrationTestimonials from './RegistrationTestimonials';
import CandidateSingleRegistrationPage from './candidate/CandidateSingleRegistrationPage';
import { Message } from '../../lib/constants/messages';
import { userCacheDataService } from '../../lib/api/userCacheData';
import { USER_DATA_CACHE_KEY, USER_DATA_IP_ADDRESS_KEY, USER_DATA_USER_AGENT_KEY } from '../../config/constants';
import secureLocalStorage from 'react-secure-storage';
import { signOut } from '../../redux/user';
import { sessionStorageClearAll } from '../../components/storage/sessionStorageManager';
import useUser from '../../hooks/useSelector';
import {
    localStorageGetItem,
    localStorageRemoveItem,
    localStorageSetItem,
} from '../../components/storage/localStorageManager';
import { useAppDispatch } from '../../redux/reduxhooks';
import Prompt from './utils/prompt';
import { tokenManager } from '../../lib/token-manager';

type Props = {
    candidateId?: string;
    managerId?: string;
};

const AuthModal: React.FC<Props> = ({ candidateId, managerId }) => {
    const [unclaimedData, setUnclaimedData] = useState<any>();
    const [showUI, setShowUI] = useState(false);

    // const urlPath = history.location;
    const urlPath = useLocation();
    const dispatch = useAppDispatch();

    // const [activeTab, setActiveTab] = useState(urlPath.pathname === '/signup' ? 'auth-social' : 'auth-social');
    const [activeTab, setActiveTab] = useState('auth-social');
    const [rerenderKey, setRerenderKey] = useState(0);
    const [candidateType, setCandidateType] = useState('');
    const [authType, setAuthType] = useState('');
    const [checkIcon, setCheckIcon] = useState('');
    const [pageLoading, setPageLoading] = useState(false);
    const [showLoginButtonType, setShowLoginButtonType] = useState(false);
    const [showSelectAccountType, setShowSelectAccountType] = useState(true);
    const [signAs, setSignAs] = useState('');
    const [KYCEmail, setKYCEmail] = useState('');
    const [digioSuccessData, setDigioSuccessData] = useState();
    const [showPasswordTab, setShowPasswordTab] = useState(false);
    const [showOTPBtn, setShowOTPBtn] = useState(true);
    const [showNextTab, setShowNextTab] = useState(false);

    const navigate = useNavigate();

    const [disableCandidateTypeBtn, setDisableCandidateTypeBtn] = useState(false);
    const [disableManagerTypeBtn, setDisableManagerTypeBtn] = useState(false);

    const { ConfirmCandidateInvitationId, AffiliateReferral, ConfirmUnclaimedCandidateInvitationId } =
        queryString.parse(urlPath.search);

    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [ipAddress, setIpAddress] = useState('');
    const [userAgent, setUserAgent] = useState('');
    const hasUser = useUser();

    useEffect(() => {
        if (ConfirmCandidateInvitationId || (showUI && unclaimedData && unclaimedData.claimedType === 'candidate')) {
            setActiveTab('/signup');
            setCheckIcon('candidate');
            setCandidateType('candidate');
            // setShowSelectAccountType(false);
            setDisableManagerTypeBtn(true);
            setSignAs('candidate');
        }

        if (AffiliateReferral || (showUI && unclaimedData && unclaimedData.claimedType === 'company')) {
            setActiveTab('/signup');
            setCheckIcon('company');
            setCandidateType('company');
            setSignAs('company');
            setDisableCandidateTypeBtn(true);
            if (AffiliateReferral) {
                localStorageSetItem('referral', AffiliateReferral, true);
            }

            if (unclaimedData.claimedType === 'company') {
                setShowLoginButtonType(true);
            }
            // setShowSelectAccountType(false);
        }

        if (ConfirmUnclaimedCandidateInvitationId) {
            setActiveTab('auth-social');
            setCheckIcon('candidate');
            setCandidateType('candidate');
            // setShowSelectAccountType(false);
            setDisableManagerTypeBtn(true);
            setSignAs('candidate');
            setAuthType('customAuth');
            localStorageSetItem('unclaimedNewReg', ConfirmUnclaimedCandidateInvitationId, true);
        }

        if (hasUser && hasUser) {
            dispatch(signOut(navigate));
        }
    }, [ConfirmCandidateInvitationId, AffiliateReferral, unclaimedData, ConfirmUnclaimedCandidateInvitationId]);

    const tabs = useMemo(
        () => [
            {
                key: 'auth-social',
                component: (
                    <AuthSocial
                        key={rerenderKey}
                        goToRegistration={() => {
                            if (candidateId) {
                                setActiveTab('');
                            } else if (managerId) {
                                setActiveTab('');
                            } else {
                                setActiveTab('reg-choice');
                            }
                        }}
                    />
                ),
            },
            // {
            //     key: 'account-details',
            //     component: (
            //         <>
            //             {authType === 'customAuth' && (
            //                 <CustomAuth
            //                     candidateType={signAs}
            //                     disableButton={!checkIcon}
            //                     handleSelect={(key: string, key2: string) => {
            //                         setActiveTab(key);
            //                         setCandidateType(key2);
            //                     }}
            //                     setPageLoading={(item) => setPageLoading(item)}
            //                     setShowSelectAccountType={setShowSelectAccountType}
            //                 />
            //             )}
            //         </>
            //     ),
            // },
            {
                key: 'basic-details',
                component: (
                    <>
                        {/* {candidateType === 'candidate' && digioSuccessData ? ( */}
                        {candidateType === 'candidate' ? (
                            // <CandidateStep2
                            //     handleDatAndTab={(key: string, key2: string) => {
                            //         setTimeout(() => {
                            //             setActiveTab(key);
                            //             setCandidateType(key2);
                            //         }, 300);
                            //     }}
                            //     candidateId={candidateId}
                            //     key={rerenderKey + 1}
                            // />
                            <CandidateSingleRegistrationPage
                                handleDatAndTab={(key: string, key2: string) => {
                                    setTimeout(() => {
                                        setActiveTab(key);
                                        setCandidateType(key2);
                                    }, 300);
                                }}
                                digioSuccessData={digioSuccessData}
                                candidateId={candidateId}
                                key={rerenderKey + 1}
                                hasUnsavedChanges={(value) => setHasUnsavedChanges(value)}
                            />
                        ) : (
                            <>
                                {/* <ManagerStep2
                                    handleDatAndTab={(key: string, key2: string) => {
                                        setTimeout(() => {
                                            setActiveTab(key);
                                            setCandidateType(key2);
                                        }, 300);
                                    }}
                                    managerId={managerId}
                                    key={rerenderKey + 2}
                                />                                */}
                                <ManagerSingleRegistrationPage
                                    handleSelect={(key: string, key2: string) => {
                                        setActiveTab(key);
                                        setCandidateType(key2);
                                    }}
                                    managerId={managerId}
                                    key={rerenderKey + 4}
                                    selectedAuthType={authType}
                                    hasUnsavedChanges={(value) => setHasUnsavedChanges(value)}
                                />
                            </>
                        )}
                    </>
                ),
            },
            {
                key: 'Additional-details',
                component:
                    candidateType === 'candidate' ? (
                        <CandidateStep3
                            handleSelect={(key: string, key2: string) => {
                                setActiveTab(key);
                                setCandidateType(key2);
                            }}
                            candidateId={candidateId}
                            key={rerenderKey + 3}
                        />
                    ) : (
                        <ManagerStep3
                            handleSelect={(key: string, key2: string) => {
                                setActiveTab(key);
                                setCandidateType(key2);
                            }}
                            managerId={managerId}
                            key={rerenderKey + 4}
                        />
                    ),
            },
        ],
        [rerenderKey, authType, signAs, checkIcon, candidateType, candidateId, managerId, activeTab, KYCEmail]
    );

    const confirmUnsavedChanges = (event: any) => {
        try {
            if (hasUnsavedChanges) {
                let cacheData = secureLocalStorage.getItem(USER_DATA_CACHE_KEY) as any;
                let jsonString = JSON.stringify(cacheData);
                if (cacheData?.email || cacheData?.Email) {
                    userCacheDataService.saveOxData({
                        // id: "",
                        ipAddress: ipAddress,
                        emailId: cacheData?.email || cacheData?.Email,
                        userAgent: userAgent,
                        jsonData: jsonString,
                    });
                }

                event.preventDefault();
                event.returnValue = 'You have unsaved changes. Do you really want to leave?';
                return '';
            }
        } catch (error) {}
    };

    useEffect(() => {
        window.addEventListener('beforeunload', confirmUnsavedChanges);
        return () => window.removeEventListener('beforeunload', confirmUnsavedChanges);
    }, [hasUnsavedChanges]);

    useEffect(() => {
        window.addEventListener('beforeunload', confirmUnsavedChanges);

        // Get the user agent from the browser.
        setUserAgent(navigator.userAgent);
        secureLocalStorage.setItem(USER_DATA_USER_AGENT_KEY, navigator.userAgent);

        //get user ipaddress
        (async () => {
            try {
                const response = await fetch('https://free.freeipapi.com/api/json');
                const data = await response.json();
                setIpAddress(data.ipAddress);
                secureLocalStorage.setItem(USER_DATA_IP_ADDRESS_KEY, data.ipAddress);
            } catch (err) {
                console.error(err);
            }
        })();

        sessionStorageClearAll();
        return () => {
            try {
                let cacheData = secureLocalStorage.getItem(USER_DATA_CACHE_KEY) as any;

                if (cacheData) {
                    let ip = secureLocalStorage.getItem(USER_DATA_IP_ADDRESS_KEY)?.toString() || 'NA';
                    let ua = secureLocalStorage.getItem(USER_DATA_USER_AGENT_KEY)?.toString() || 'NA';
                    if (cacheData?.email || cacheData?.Email) {
                        userCacheDataService.saveOxData({
                            // id: "",
                            ipAddress: ip,
                            emailId: cacheData?.email || cacheData?.Email,
                            userAgent: ua,
                            jsonData: JSON.stringify(cacheData),
                        });
                    }
                }

                window.removeEventListener('beforeunload', confirmUnsavedChanges);
            } catch (error) {}
        };
    }, []);

    useEffect(() => {
        const storageData = localStorageGetItem('unclaimed', false);
        const claimedType = localStorageGetItem('claimedType', true);
        if (claimedType === 'company') {
            setSignAs(claimedType);
            setCheckIcon('company');
            setCandidateType('company');
            setShowLoginButtonType(true);
        }
        if (storageData) {
            setUnclaimedData({ ...storageData, avatarUrl: '' });
            setShowUI(true);
        }
    }, []);

    return (
        <>
            {urlPath.pathname === '/signup' ? (
                pageLoading ? (
                    <PageLoader />
                ) : (
                    <>
                        <Helmet>
                            <title>
                                OfferX - Sign Up | Be A Part Of The Modern Hiring Process Without Candidate Backout
                            </title>
                            <meta
                                name="description"
                                content="Embrace a world of boundless career possibilities by creating an OfferX account. Build your profile, upload your resume, and embark on connecting with top employers in your industry."
                            />
                        </Helmet>
                        <div className="lt-bg-gray-10 vh-100 overflow-auto">
                            <header className="landing-page">
                                <nav className="navbar navbar-expand-lg navbar-toggleable-sm navbar-light py-0">
                                    <div className="container">
                                        <Link to={routes.main} className="navbar-brand py-0 fs-28 fw-700">
                                            <img loading='lazy'src={websitelogo} className="site-logo" alt="OfferX Logo"></img>
                                        </Link>
                                        <button
                                            className="navbar-toggler border-0"
                                            type="button"
                                            data-bs-target="#offcanvasNavbar"
                                            data-bs-toggle="offcanvas"
                                            aria-label="Toggle navigation"
                                        >
                                            <span className="navbar-toggler-icon" />
                                        </button>
                                        <div
                                            // aria-hidden="true"
                                            // aria-labelledby="offcanvasNavbarLabel"
                                            className="flex-sm-row-reverse offcanvas offcanvas-end"
                                            id="offcanvasNavbar"
                                            data-bs-scroll="true"
                                            tabIndex={0}
                                        >
                                            <div className="offcanvas-header ml-auto">
                                                <button
                                                    data-sider-close
                                                    aria-label="Close"
                                                    className="btn-close text-reset ms-auto"
                                                    data-bs-dismiss="offcanvas"
                                                    type="button"
                                                />
                                            </div>
                                            <div className="offcanvas-body mobile-offcanvas">
                                                <ul className="navbar-nav flex-grow">
                                                    <li className="nav-item">
                                                        {/* <NavLink
                                                            exact
                                                            to={routes.contact}
                                                            activeClassName="active"
                                                            className="nav-link text-dark lt-text-footer text-decoration-underline"
                                                            tabIndex={0}
                                                            title="Contact Us"
                                                        >
                                                            <div className="d-flex align-items-center">
                                                                <div>
                                                                    <i className="bi bi-headset fs-20"></i>
                                                                </div>
                                                                <div>Contact Us</div>
                                                            </div>
                                                        </NavLink> */}

                                                        <a
                                                            target="_blank"
                                                            href={routes.contact}
                                                            className="nav-link lt-text-footer text-decoration-underline"
                                                            tabIndex={0}
                                                            title="Contact Us"
                                                        >
                                                            <div className="d-flex align-items-center">
                                                                <div>
                                                                    <i className="bi bi-headset fs-20"></i>
                                                                </div>
                                                                <div>Contact Us</div>
                                                            </div>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </nav>
                            </header>

                            <div className="container">
                                <div className="row">
                                    <div className="col-md-12 my-3">
                                        <span
                                            className="text-secondary cursor-pointer"
                                            onClick={() => {
                                                const takeToMainPage = localStorageGetItem('claimedType');
                                                const token = tokenManager.getToken();
                                                if (takeToMainPage === 'company' && !token && !showLoginButtonType) {
                                                    navigate(routes.main);
                                                    localStorageRemoveItem('claimedType');
                                                    return;
                                                }

                                                if (authType === 'customAuth') {
                                                    if (candidateType === 'company' || candidateType === 'candidate') {
                                                        if (
                                                            activeTab === 'basic-details' ||
                                                            activeTab === 'Additional-details'
                                                        ) {
                                                            setShowPasswordTab(true);
                                                            setActiveTab('/signup');
                                                            setAuthType('customAuth');
                                                            setShowSelectAccountType(true);
                                                            setShowNextTab(true);
                                                        } else {
                                                            if (candidateType === 'candidate') {
                                                                if (showPasswordTab) {
                                                                    setShowNextTab(false);
                                                                    setShowPasswordTab(false);
                                                                    setAuthType('');
                                                                    setShowLoginButtonType(true);
                                                                } else {
                                                                }
                                                            } else {
                                                                if (showPasswordTab) {
                                                                    setShowNextTab(false);
                                                                    setShowPasswordTab(false);
                                                                    setShowOTPBtn(true);
                                                                } else {
                                                                    setAuthType('');
                                                                    setShowSelectAccountType(true);
                                                                }
                                                            }
                                                        }
                                                    } else {
                                                        setAuthType('');
                                                    }
                                                } else if (showSelectAccountType) {
                                                    if (
                                                        history?.location?.search?.includes(
                                                            'ConfirmCandidateInvitationId'
                                                        )
                                                    ) {
                                                        if (authType === '') {
                                                            if (!showLoginButtonType) {
                                                                navigate(routes.main);
                                                            } else {
                                                                setShowLoginButtonType(false);
                                                            }
                                                        } else {
                                                            navigate(routes.main);
                                                        }
                                                    } else {
                                                        if (
                                                            showLoginButtonType &&
                                                            history?.location?.search?.includes(
                                                                'ConfirmCandidateInvitationId'
                                                            )
                                                        ) {
                                                            navigate(routes.main);
                                                        } else {
                                                            if (takeToMainPage === 'company' && !token) {
                                                                navigate(routes.main);
                                                            } else {
                                                                if (
                                                                    showLoginButtonType &&
                                                                    history?.location?.pathname?.includes('/signup')
                                                                ) {
                                                                    setShowLoginButtonType(false);
                                                                } else {
                                                                    const localAuthType =
                                                                        localStorageGetItem('authType');
                                                                    if (
                                                                        localAuthType === 'microsoft' ||
                                                                        localAuthType === 'google'
                                                                    ) {
                                                                        navigate(routes.main);
                                                                    } else {
                                                                        navigate(-1);
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                } else if (showLoginButtonType) {
                                                    setShowSelectAccountType(true);
                                                    setActiveTab('/signup');
                                                } else {
                                                    setShowSelectAccountType(true);
                                                }
                                            }}
                                        >
                                            <i className="bi bi-chevron-left lt-text-secondary-alt me-0"></i> Back
                                        </span>
                                    </div>
                                </div>
                                {showSelectAccountType ? (
                                    <div className="row screen-height d-flex align-items-center ms-lg-2  ms-md-2 ms-0">
                                        <div className="col-lg-7 order-lg-1 order-md-1 order-2 mobile-hide">
                                            <RegistrationTestimonials />
                                        </div>
                                        <div className="col-lg-5 order-lg-2 order-md-2 order-1">
                                            <div className="">
                                                <div className="col-md-12">
                                                    <div className="tab-content" id="nav-tabContent">
                                                        <div
                                                            className="tab-pane fade show active"
                                                            id="nav-home"
                                                            role="tabpanel"
                                                            // aria-labelledby="nav-home-tab"
                                                        >
                                                            <div
                                                                className="mx-auto d-block"
                                                                style={{ maxWidth: '500px' }}
                                                            >
                                                                {authType !== 'customAuth' && (
                                                                    <div className="card lt-shadow-sm">
                                                                        <div className="login-card-body">
                                                                            <div className="flex-column">
                                                                                {!showLoginButtonType ? (
                                                                                    <>
                                                                                        <div className="w-100 mb-4 text-center">
                                                                                            <h1 className="fs-32 fw-600">
                                                                                                Let's Get Started
                                                                                            </h1>
                                                                                            <div className="fs-16 lt-text-secondary">
                                                                                                Select Your Account Type
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="mb-4">
                                                                                            <div className="mb-3">
                                                                                                <div className="">
                                                                                                    <label
                                                                                                        onClick={() => {
                                                                                                            sessionStorageClearAll();
                                                                                                            setCheckIcon(
                                                                                                                'company'
                                                                                                            );
                                                                                                            setSignAs(
                                                                                                                'company'
                                                                                                            );
                                                                                                            setCandidateType(
                                                                                                                'company'
                                                                                                            );
                                                                                                        }}
                                                                                                    >
                                                                                                        <button
                                                                                                            disabled={
                                                                                                                disableManagerTypeBtn
                                                                                                            }
                                                                                                            className={`${
                                                                                                                disableManagerTypeBtn &&
                                                                                                                'op-disabled'
                                                                                                            } panel panel-default card-input op-card-box`}
                                                                                                        >
                                                                                                            <div className="text-start">
                                                                                                                <div className="d-flex justify-content-between align-items-center">
                                                                                                                    <div className="d-flex justify-content-start align-items-center">
                                                                                                                        <img
                                                                                                                            src={
                                                                                                                                IconManager
                                                                                                                            }
                                                                                                                            alt="Company"
                                                                                                                            width={
                                                                                                                                36
                                                                                                                            }
                                                                                                                            className="mb-0"
                                                                                                                        />
                                                                                                                        <div className="fs-16 mb-0 op-color ms-2 mt-1">
                                                                                                                            Company
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                    <i
                                                                                                                        className={`bi ${
                                                                                                                            checkIcon ===
                                                                                                                            'company'
                                                                                                                                ? 'bi-check-circle-fill lt-text-primary-alt'
                                                                                                                                : 'bi-circle lt-text-disabled'
                                                                                                                        } mt-0 fs-20`}
                                                                                                                    ></i>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </button>
                                                                                                    </label>
                                                                                                </div>
                                                                                                <div className="mt-3">
                                                                                                    <label
                                                                                                        onClick={() => {
                                                                                                            sessionStorageClearAll();
                                                                                                            setCheckIcon(
                                                                                                                'candidate'
                                                                                                            );
                                                                                                            setCandidateType(
                                                                                                                'candidate'
                                                                                                            );
                                                                                                            setSignAs(
                                                                                                                'candidate'
                                                                                                            );
                                                                                                        }}
                                                                                                    >
                                                                                                        <input
                                                                                                            type="radio"
                                                                                                            name="product"
                                                                                                            className="card-input-element"
                                                                                                        />

                                                                                                        <button
                                                                                                            disabled={
                                                                                                                disableCandidateTypeBtn
                                                                                                            }
                                                                                                            className={`${
                                                                                                                disableCandidateTypeBtn &&
                                                                                                                'op-disabled'
                                                                                                            } panel panel-default card-input op-card-box`}
                                                                                                        >
                                                                                                            <div className="d-flex justify-content-between align-items-center">
                                                                                                                <div className="d-flex justify-content-start">
                                                                                                                    <img
                                                                                                                        src={
                                                                                                                            IconCandidate
                                                                                                                        }
                                                                                                                        alt="Candidate"
                                                                                                                        width={
                                                                                                                            36
                                                                                                                        }
                                                                                                                        className="mb-0"
                                                                                                                    />
                                                                                                                    <div className="fs-16 mb-0 op-color ms-2 mt-1">
                                                                                                                        Candidate
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <i
                                                                                                                    className={`bi ${
                                                                                                                        checkIcon ===
                                                                                                                        'candidate'
                                                                                                                            ? 'bi-check-circle-fill lt-text-primary-alt'
                                                                                                                            : 'bi-circle lt-text-disabled'
                                                                                                                    } mt-1 fs-20`}
                                                                                                                ></i>
                                                                                                            </div>
                                                                                                        </button>
                                                                                                    </label>
                                                                                                </div>
                                                                                            </div>
                                                                                            <button
                                                                                                disabled={Boolean(
                                                                                                    !candidateType
                                                                                                )}
                                                                                                className="btn btn-primary w-100 h-44"
                                                                                                onClick={() => {
                                                                                                    setShowLoginButtonType(
                                                                                                        true
                                                                                                    );
                                                                                                }}
                                                                                            >
                                                                                                Next
                                                                                            </button>
                                                                                            <div className="fs-14 mt-3 lt-text-secondary text-center">
                                                                                                Already have an account?{' '}
                                                                                                <Link
                                                                                                    to={
                                                                                                        routes.signinSignup
                                                                                                    }
                                                                                                >
                                                                                                    <a className="lt-text-primary-alt cursor-pointer">
                                                                                                        {' '}
                                                                                                        Log In
                                                                                                    </a>
                                                                                                </Link>
                                                                                            </div>
                                                                                        </div>
                                                                                    </>
                                                                                ) : (
                                                                                    <div>
                                                                                        <CommanTab
                                                                                            setPageLoading={(item) =>
                                                                                                setPageLoading(item)
                                                                                            }
                                                                                            setDigioSuccessData={
                                                                                                setDigioSuccessData
                                                                                            }
                                                                                            key={rerenderKey}
                                                                                            disableButton={!checkIcon}
                                                                                            setAuthType={setAuthType}
                                                                                            handleSelect={(
                                                                                                key: string,
                                                                                                key2: string,
                                                                                                value: any
                                                                                            ) => {
                                                                                                setActiveTab(key);
                                                                                                setCandidateType(key2);
                                                                                                setKYCEmail(value);
                                                                                            }}
                                                                                            candidateType={
                                                                                                candidateType
                                                                                            }
                                                                                            setShowSelectAccountType={
                                                                                                setShowSelectAccountType
                                                                                            }
                                                                                            goToRegistration={() => {
                                                                                                if (candidateId) {
                                                                                                    setActiveTab(
                                                                                                        'account-details'
                                                                                                    );
                                                                                                    setCandidateType(
                                                                                                        'candidate'
                                                                                                    );
                                                                                                } else if (managerId) {
                                                                                                    setActiveTab(
                                                                                                        'account-details'
                                                                                                    );
                                                                                                    setCandidateType(
                                                                                                        'company'
                                                                                                    );
                                                                                                } else {
                                                                                                    setActiveTab(
                                                                                                        'select-account'
                                                                                                    );
                                                                                                    setRerenderKey(
                                                                                                        rerenderKey + 1
                                                                                                    );
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {authType === 'customAuth' && (
                                                                    <CustomAuth
                                                                        candidateType={signAs}
                                                                        isNewRegUnclaimedAcc={
                                                                            ConfirmUnclaimedCandidateInvitationId
                                                                                ? true
                                                                                : false
                                                                        }
                                                                        claimedCandidateData={unclaimedData || ''}
                                                                        newRegUnclaimedId={
                                                                            ConfirmUnclaimedCandidateInvitationId?.toString() ||
                                                                            ''
                                                                        }
                                                                        setDigioSuccessData={setDigioSuccessData}
                                                                        disableButton={!checkIcon}
                                                                        handleSelect={(
                                                                            key: string,
                                                                            key2: string,
                                                                            value: any
                                                                        ) => {
                                                                            setActiveTab(key);
                                                                            setCandidateType(key2);
                                                                            setKYCEmail(value?.email);
                                                                        }}
                                                                        setPageLoading={(item) => setPageLoading(item)}
                                                                        setShowSelectAccountType={
                                                                            setShowSelectAccountType
                                                                        }
                                                                        setShowPasswordTab={setShowPasswordTab}
                                                                        showPasswordTab={showPasswordTab}
                                                                        setShowOTPBtn={setShowOTPBtn}
                                                                        showOTPBtn={showOTPBtn}
                                                                        activeTab={activeTab}
                                                                        setShowNextTab={setShowNextTab}
                                                                        showNextTab={showNextTab}
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <div className="row justify-content-center">
                                            {activeTab === 'basic-details' && candidateType === 'candidate' ? (
                                                <div className="col-lg-7 col-md-12 col-12 d-flex justify-content-center align-items-center">
                                                    <div>
                                                        <div>
                                                            <img
                                                                loading='lazy'
                                                                src={candiDetails}
                                                                className="mobile-hide mt-5 img-fluid"
                                                                // style={{ width: '80%' }}
                                                                alt=""
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="col-lg-7 col-md-12 col-12 d-flex justify-content-center align-items-center">
                                                    {' '}
                                                    {/* my-auto */}
                                                    <div>
                                                        <img
                                                            src={compDetails}
                                                            className="mobile-hide mt-5 img-fluid"
                                                            // style={{ width: '80%' }}
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            <div className="col-lg-5 col-md-12 col-12">
                                                <div className="tab-content" id="v-pills-tabContent">
                                                    <div
                                                        className="tab-pane fade show active"
                                                        id="AddCandidateTab2"
                                                        role="tabpanel"
                                                        // aria-labelledby="AddCandidate"
                                                    >
                                                        <div className="mt-3">
                                                            {tabs.find((item) => item.key === activeTab)?.component}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </>
                )
            ) : (
                <>
                    <div
                        className="modal fade"
                        id="SignInSignUp"
                        data-bs-backdrop="static"
                        data-bs-keyboard="false"
                        tabIndex={-1}
                        // aria-labelledby="SignInSignUpLabel"
                        aria-hidden="true"
                    >
                        <div
                            className={`modal-dialog modal-dialog-centered ${
                                activeTab === 'auth-social' || activeTab === 'reg-choice' ? 'modal-xl' : 'modal-lg'
                            }`}
                        >
                            <div className="modal-content">
                                <div className="lt-modal-header lt-modal-login-header">
                                    <button
                                        type="button"
                                        data-close
                                        className="btn-close login-close"
                                        data-bs-dismiss="modal"
                                        title="Close"
                                        aria-label="Close"
                                        onClick={() => {
                                            setActiveTab('auth-social');
                                            setRerenderKey(Date.now());
                                        }}
                                    />
                                </div>
                                {tabs.find((item) => item.key === activeTab)?.component}
                            </div>
                        </div>
                    </div>
                </>
            )}

            <Prompt when={hasUnsavedChanges} message={Message.UNSAVED_CHANGES_MESSAGE} />
        </>
    );
};

export default AuthModal;
